<template>
  <v-hover
    v-slot:default="{ hover }"
  >
    <BaseMyCard
      v-bind="$attrs"
      v-on="$listeners"
      v-resize="onResize"
      class="ma-2"
      :hover="hover"
      :scale="1.02"
      :select="select && select.postulante._id === applicant.postulante._id"
    >
      <v-container class="px-8 py-2 d-flex flex-wrap">
        <v-row>
          <v-col class="py-0 d-flex align-center flex-wrap">
            <v-list-item-avatar
              size="64"
              :color="!applicant.postulante.informacion_personal.profile_image ? 'primary' : ''"
              class="d-flex justify-center"
            >
              <v-img
                v-if="!!applicant.postulante.informacion_personal.profile_image"
                :src="`${host}${applicant.postulante.informacion_personal.profile_image}`" :alt="applicant.postulante.informacion_personal.logo"
              ></v-img>
              <span v-else class="white--text headline font-weight-bold">
                {{ initialsName }}
              </span>
            </v-list-item-avatar>
            <div class="d-flex flex-column align-end">
              <v-col>
                <v-list-item-subtitle class="font-weight-ligth grey--text" style="white-space: normal">
                  <span class="caption font-weight-ligth grey--text">
                    {{ !age ? 'Sin edad establecida' : `${age} años` }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-title class="subtitle font-weight-bold" style="white-space: break-spaces;">
                  {{ applicant.postulante.informacion_personal.nombres }} {{ applicant.postulante.informacion_personal.apellidos }}
                </v-list-item-title>
                <v-list-item-subtitle
                  v-if="applicant.postulante.informacion_contacto && applicant.postulante.informacion_contacto.provincia"
                  class="font-weight-ligth grey--text" style="white-space: normal"
                >
                  <v-icon small >mdi-map-marker-outline</v-icon>
                  <span>
                    {{ applicant.postulante.informacion_contacto.provincia }}, {{ applicant.postulante.informacion_contacto.ciudad }}
                  </span>
                </v-list-item-subtitle>
              </v-col>
              <!-- <div class="caption grey--text mt-1 font-weight-bold">
                <v-icon small class="mr-1">mdi-clock-outline</v-icon>
                {{ timeElapsed(applicant.createdAt) }}
              </div> -->
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex justify-end">
            <div v-if="requirementsItMeets" class="ml-3 d-flex align-center" style="cursor: auto">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="ml-3 d-flex align-center">
                    <v-icon color="error">mdi-alert-circle</v-icon>
                  </div>
                </template>
                <span v-html="requirementsItMeets">
                </span>
              </v-tooltip>
            </div>
            <div v-if="applicant.postulante.informacion_personal.tiene_discapacidad" class="ml-3 d-flex align-center" style="cursor: auto">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">mdi-human-wheelchair</v-icon>
                </template>
                <span>Persona con discapacidad</span>
              </v-tooltip>
            </div>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <div v-on="on" class="ml-3 d-flex align-center" style="cursor: auto">
                  <v-icon v-if="applicant.curriculum_leido" color="info">mdi-eye</v-icon>
                  <v-icon v-else color="error">mdi-eye-off</v-icon>
                </div>
              </template>
              <span>
                Hoja de vida 
                <span v-if="applicant.curriculum_leido">leída</span>
                <span v-else>no leída</span>
              </span>
            </v-tooltip>
            <div class="ml-3 d-flex align-center" style="cursor: auto">
              <v-icon v-if="applicant.es_favorito" color="primary">mdi-star</v-icon>
              <v-icon v-else color="primary">mdi-star-outline</v-icon>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </BaseMyCard>
  </v-hover>
</template>

<script>
import { windowSizeMixin } from '@/mixin/windowSizeMixin.js';
import config from '@/config';
export default {
  mixins: [windowSizeMixin],
  props: {
    applicant: {
      type: Object,
      required: true,
    },
    requerimientos: {
      type: Object,
    },
    aviso: {
      type: Object,
      required: true,
    },
    select: {
      type: Object,
    }
  },
  data() {
    return {
      host: config.host,
    }
  },
  computed: {
    initialsName() {
      const nombres = this.applicant.postulante.informacion_personal.nombres;
      const apellidos = this.applicant.postulante.informacion_personal.apellidos;
      if (nombres && !apellidos) return nombres[0].toUpperCase();
      else if (!nombres && apellidos) return apellidos[0].toUpperCase();
      else if (nombres && apellidos)
        return `${nombres[0].toUpperCase()}${apellidos[0].toUpperCase()}`;
      else return '';
    },
    age() {
      if (!this.applicant.postulante.informacion_personal.fecha_nacimiento) return '';
      return this.$moment().diff(this.applicant.postulante.informacion_personal.fecha_nacimiento, "years");
    },
    requirementsItMeets() {
      let message = '';
      if (!this.requerimientos) return '';

      let fulfillEducation;
      if (this.requerimientos.educacion) {
        fulfillEducation = this.applicant.postulante.educacion
          .find(educacion => educacion.tipo_estudio === this.requerimientos.educacion.nivel_educativo
            && educacion.estado === this.requerimientos.educacion.estado);
      }

      let fulfillWorkExperience;
      if (this.requerimientos.experiencia) {
        fulfillWorkExperience = this.applicant.postulante.experiencia_laborales
          .find(work => work.area_puesto === this.aviso.area
          && this.$moment(work.fecha_fin || new Date()).diff(work.fecha_inicio, 'years') >= this.requerimientos.experiencia.experiencia_minima);
      }

      const languageLevel = {
        'Básico': 0,
        'Intermedio': 1,
        'Avanzado': 2,
        'Nativo': 3,
      }

      let fulfillLanguage;
      if (this.requerimientos.idiomas) {
        fulfillLanguage = this.requerimientos.idiomas
          .every(idioma => {
            const lenguage = this.applicant.postulante.idiomas.find(language => language.idioma === idioma.idioma);
            return lenguage
              && (languageLevel[lenguage.nivel_escrito] >= languageLevel[idioma.nivel]
               || languageLevel[lenguage.nivel_escrito] >= languageLevel[idioma.nivel]);
          });
      }
      
      if (this.requerimientos.edad && (this.age <= this.requerimientos.edad.edad_min || this.age >= this.requerimientos.edad.edad_max)) message += '<div>No cumple con el rango de edad solicitado</div>';
      if (this.requerimientos.sexo && this.applicant.postulante.informacion_personal.genero !== this.requerimientos.sexo.sexo) message += '<div>No cumple con el género solicitado</div>';
      if (this.requerimientos.educacion && !fulfillEducation) message += '<div>No cumple con el nivel educativo solicitado</div>';
      if (this.requerimientos.experiencia && !fulfillWorkExperience) message += '<div>No cumple con la experiencia laboral en el área indicada</div>';
      if (this.requerimientos.idiomas && this.requerimientos.idiomas.length && !fulfillLanguage) message += '<div>No cumple con el nivel de conocimientos mínimos solicitados</div>';
      if (this.requerimientos.salario && (this.applicant.salario_pretendido <= this.requerimientos.salario.salario_min || this.applicant.salario_pretendido >= this.requerimientos.salario.salario_max)) message += '<div>El salario pretendido no cumple con el rango establecido</div>';
      return message;
    },
  },
  created() {
    // console.log('requerimientos: ', this.requerimientos);
  },
  methods: {
    formatDate(date) {
      return this.$moment(date).format('DD/MM/YYYY');
    },
    timeElapsed(date) {
      return this.$moment(date).fromNow();
    },
    favorite() {
      this.$emit('favorite', this.applicant)
    }
  }
}
</script>

<style>

</style>